import isSxSDisplayed from './isSxSDisplayed';
import { isPreviewPaneDisplayed } from 'owa-preview-pane-store';
/**
 * This function returns true if any SxS is being displayed
 * For now it handles both legacy and refactored SxS
 */
export default function isAnySxSDisplayed() {
    return isSxSDisplayed() || isPreviewPaneDisplayed();
}
//# sourceMappingURL=isAnySxSDisplayed.js.map